import { apiService } from './api.service';
import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { Inverter } from '../types';

class InvertersService {
  async getInvertersByBrand(brandId: string, status: string = STATUS_FILTER_VALUES.ALL): Promise<Inverter[]> {
    const params = { 
      [QUERY_PARAMS.BRAND_ID]: brandId,
      [QUERY_PARAMS.STATUS]: status
    };
    return apiService.get<Inverter[]>(CR_API_ENDPOINTS.INVERTERS, params);
  }

  async getAllInverters(status: string = STATUS_FILTER_VALUES.ALL): Promise<Inverter[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Inverter[]>(CR_API_ENDPOINTS.INVERTERS, params);
  }

  async getInverterById(id: string): Promise<Inverter> {
    return apiService.get<Inverter>(`${CR_API_ENDPOINTS.INVERTERS}/${id}`);
  }

  async createInverter(inverterData: {
    model: string;
    manufacturerId: string;
  }): Promise<Inverter> {
    return apiService.post<Inverter>(CR_API_ENDPOINTS.INVERTERS, inverterData);
  }
}

export const invertersService = new InvertersService();